export * from '@mui/material';
export * from '@mui/material/transitions';
import MuiTrapFocus from '@mui/material/Unstable_TrapFocus';
export const TrapFocus = MuiTrapFocus;
export * from '@mui/material/Unstable_TrapFocus';
